import { baseApi } from './baseApi';

export interface CurrentPlanResponse {
  /** Organization.Plan as stored locally (kept in sync by Stripe webhook). */
  plan: string;
  /**
   * Misma regla que el backend aplica al bypass de plan: Profesional o trial vigente.
   * La calcula el servidor para que el front no replique la fecha de fin del trial.
   * Opcional solo por compatibilidad con respuestas cacheadas de la API anterior.
   */
  hasProBundle?: boolean;
}

export const organizationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Returns the organization's current plan from the local DB — does NOT hit
     * Stripe. Used by useIsModuleEnabled to decide Pro-plan bypass without making
     * UI module visibility depend on Stripe API liveness.
     */
    getCurrentPlan: builder.query<CurrentPlanResponse, void>({
      query: () => '/organization/current-plan',
      // Plan changes after subscription mutations — invalidate the same tag the
      // Stripe checkout/cancel/reactivate flows use so the UI re-syncs.
      providesTags: ['AppSettings'],
    }),
  }),
});

export const { useGetCurrentPlanQuery } = organizationApi;
